<template>
  <div class="configBatchAuthVue">
    <div class="col-md-10 col-sm-9 u-pad-all-25 c-common-box-shadow u-bg-color-fff">
        <!-- batch-authorize -->
        <div class="batch-authorize">

            <h3 class="u-cmn-botmargin">Batch Authorize <span class="c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></h3>

            <div class="clearfix">
                <div class="row">
                    <div class="col-md-6 col-sm-12 u-margin-20 ">
                        <div class="u-cmn-padding u-bg-color-light-gray">
                            <p class="u-cmn-botmargin ps2">This page will allow you to activate multiple user accounts at once. Pressing the below button will send login details to anyone who meets the following two criteria:</p>
                            <ul class="ps2">
                                <li><i class="fa fa-check-circle" aria-hidden="true"></i>Has no password currently assigned</li>
                                <li><i class="fa fa-check-circle" aria-hidden="true"></i>Has an email on file</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 u-margin-20">
                        <div class="u-cmn-padding u-bg-color-light-gray clearfix u-padding-42">
                            <div class="col-md-4 col-sm-12">
                                <div class="u-border-radius-50 u-bg-color-fff active-user-number">
                                    {{inactiveEmployee}}
                                </div>
                        </div>
                            <div class="col-md-8 col-sm-12">
                            <p class="u-cmn-botmargin ps2">Users who will be activated   upon clicking the button.</p>
                            <a href="javascript: void(0)" @click="activeAccounts" class="c-common-btn c-common-btn--green">Activate Accounts</a>
                        </div>
                        </div>
                    </div>
                </div>


            </div>
</div>
        <!-- batch-authorize -->
    </div>
  </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    export default {
        data() {
            return {
                inactiveEmployee: 0,
                redirect_link:'',

            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            inactiveEmployeeList()
            {
              service.get('employee/getInactiveEmployees', {
                  'Authorization': this.userToken,
                  'cs3-context-clientId' : this.userClientID
              })
              .then((res) => {
                   this.inactiveEmployee = res.data.result.total;

                   //console.log('inactive emp', this.inactiveEmployee);
              }).catch((err) => {
                  console.log(err);
              });
            },
            activeAccounts(){
                service.post('employee/activateEmployees', {'client_id' : this.userClientID, 'redirect_link': this.redirect_link}, {
                    'Authorization': this.userToken
                })
                .then((res) => {
                    this.inactiveEmployeeList();
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Accounts Activated Successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            }
        },
        mounted() {

        },
        created() {
            this.inactiveEmployeeList();
            this.redirect_link = document.location.href.split('#')[0] + "#/resetPassword";
            //console.log(this.redirect_link);
            
        }

    }

</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/configuration/configBatchAuth.vue